import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css'
})
export class PrivacyPolicyComponent {

  hasScrolledToBottom: boolean = false;
  decision: 'accepted' | 'declined' | null = null;

  constructor(private router: Router) { }

  @HostListener('scroll', ['$event'])
  handleScroll(event: Event): void {
    const target = event.target as HTMLElement;
    const bottom =
      target.scrollHeight - target.scrollTop <= target.clientHeight + 50;
    if (bottom && !this.hasScrolledToBottom) {
      this.hasScrolledToBottom = true;
    }
  }

  handleAccept(): void {
    this.decision = 'accepted';
    localStorage.setItem('litspeed_privacy_accepted', 'true');
    localStorage.setItem('litspeed_privacy_date', new Date().toISOString());

    setTimeout(() => {
      this.router.navigate(['/']);
    }, 2000);
  }

  handleDecline(): void {
    this.decision = 'declined';
    localStorage.setItem('litspeed_privacy_accepted', 'false');
    localStorage.setItem('litspeed_privacy_date', new Date().toISOString());
  }

  handleDownload(): void {
    const content = document.getElementById('privacy-content')?.innerText || '';
    const blob = new Blob([content], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Litspeed_Privacy_Policy.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  reviewAgain(): void {
    this.decision = null;
  }
}
